import { FileEmpty02Icon } from "@hugeicons-pro/core-solid-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { InstitutionLogo } from "views/applications-id-report/slices/IncomeReportSlice/components/InstitutionLogo";

export const Logo = ({
  logo,
  verified_source_type
}: {
  logo?: string;
  verified_source_type?: string;
}) => {
  if (logo) return <InstitutionLogo logo={logo} />;

  if (!verified_source_type) return null;

  switch (verified_source_type) {
    case "payroll":
    case "paystub":
    case "w2":
    case "bank":
      return (
        <div className="p-2 rounded-md bg-primary-500 h-10 w-10 ">
          <HugeiconsIcon
            icon={FileEmpty02Icon}
            className="w-6 h-6 text-white"
          />
        </div>
      );

    default:
      return null;
  }
};
